<template>
  <div>
    <el-dialog
      :title="$t('lang.删除密码')"
      :visible.sync="dialogVisible"
      :before-close="onClickCancel"
    >
      <el-form
        :label-width="$i18n.locale == 'zh-CN' ? '130px' : '170px'"
        ref="ruleFormRef"
        :rules="rules"
        :model="passwordForm"
      >
        <div class="content">
          <el-form-item label=" ">
            <div class="tips">
              {{ $t("lang.您正在操作删除二级密码请完成校验") }}
            </div>
          </el-form-item>
          <el-form-item :label="$t('lang.二级密码')" prop="password">
            <el-input
              type="password"
              :placeholder="$t('lang.请输入二级密码')"
              v-model="passwordForm.password"
              show-password
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClickCancel">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickSubmit">{{
          $t("lang.确定")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    var password = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入二级密码")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      passwordForm: {
        password: "",
      },
      rules: {
        password: [{ validator: password, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions({
      passwordDel: "ZD_SecurityPasswordDel",
    }),
    show() {
      this.dialogVisible = true;
    },
    async onClickSubmit() {
      try {
        await this.$refs.ruleFormRef.validate();
        let res = await this.passwordDel({
          password: this.passwordForm.password,
        });
        if (res.success !== 1) return;
        this.$message({
          message: this.$t("lang.删除成功"),
          type: "success",
        });
        this.onClickCancel();
        this.$emit("onRefresh");
      } catch {}
    },
    onClickCancel() {
      this.dialogVisible = false;
      this.$refs.ruleFormRef.resetFields();
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  .tips {
    font-size: 16px;
    color: #666;
  }
}
/deep/ .el-dialog {
  width: 600px;
}
/deep/ .el-dialog .el-input {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
  padding-left: 40px;
}
/deep/ .el-form-item__label {
  width: 130px !important;
}
/deep/ .el-form-item__content {
  margin-left: 130px !important;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
</style>